"use client";

import { ChartLineGraphPanel } from "@/components/hlidaci-pes/chart-line-interactive/ChartLineGraphPanel";
import { ChartLineOverviewPanels } from "@/components/hlidaci-pes/chart-line-interactive/ChartLineOverviewPanels";
import { ChartSelectedOfferPanel } from "@/components/hlidaci-pes/chart-line-interactive/ChartSelectedOfferPanel";
import { useAnalysisContext } from "@/context/AnalysisContext";
import { useWatchDogContext } from "@/context/WatchDogContext";

export function ChartLineInteractive() {
  const {
    activeChart,
    setActiveChart,
    chartConfig,
    total,
    sortedFilteredData,
    handleMouseMove,
    handleMouseLeave,
    handleDataPointClick,
    pinnedDataPoint,
    hoveredDataPoint,
    analysis,
    saleEstateOffers,
  } = useAnalysisContext();
  const { editSpecificResult } = useWatchDogContext();

  const selectedOffer = pinnedDataPoint ?? hoveredDataPoint;

  return (
    <>
      <ChartLineOverviewPanels
        activeChart={activeChart}
        total={total}
        analysis={analysis}
        saleOffers={saleEstateOffers}
        avgPriceLabel={String(chartConfig.avgPrice.label)}
        medianLabel={String(chartConfig.median.label)}
        totalEstatesLabel={String(chartConfig.totalEstates.label)}
        avgPriceBeforeLabel={String(chartConfig.avgPriceBefore.label)}
        avgPriceAfterLabel={String(chartConfig.avgPriceAfter.label)}
        onSelectAvgPrice={() => setActiveChart("avgPrice")}
        onSelectAvgPriceBefore={() => setActiveChart("avgPriceBefore")}
        onSelectAvgPriceAfter={() => setActiveChart("avgPriceAfter")}
      />

      <ChartLineGraphPanel
        config={chartConfig}
        activeChart={activeChart}
        data={sortedFilteredData}
        pinnedDataPoint={pinnedDataPoint}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onDataPointClick={handleDataPointClick}
      />

      <ChartSelectedOfferPanel
        selectedOffer={selectedOffer}
        editSpecificResult={editSpecificResult}
      />
    </>
  );
}
